import { render, staticRenderFns } from "./FabledModal.vue?vue&type=template&id=d6b399a0&scoped=true"
import script from "./FabledModal.vue?vue&type=script&lang=js"
export * from "./FabledModal.vue?vue&type=script&lang=js"
import style0 from "./FabledModal.vue?vue&type=style&index=0&id=d6b399a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b399a0",
  null
  
)

export default component.exports